import { render } from "./InputCaixaDeSelecaoPreenchimento.vue?vue&type=template&id=b4a1cfc4&scoped=true"
import script from "./InputCaixaDeSelecaoPreenchimento.vue?vue&type=script&lang=js"
export * from "./InputCaixaDeSelecaoPreenchimento.vue?vue&type=script&lang=js"

import "./InputCaixaDeSelecaoPreenchimento.vue?vue&type=style&index=0&id=b4a1cfc4&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a1cfc4"],['__file',"src/components/VisualizarForm/components/InputCaixaDeSelecaoPreenchimento.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4a1cfc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4a1cfc4', __exports__)) {
    console.log('reload')
    api.reload('b4a1cfc4', __exports__)
  }
  
  module.hot.accept("./InputCaixaDeSelecaoPreenchimento.vue?vue&type=template&id=b4a1cfc4&scoped=true", () => {
    console.log('re-render')
    api.rerender('b4a1cfc4', render)
  })

}


export default __exports__